import React, { useCallback } from 'react';
import { TBookingType } from '../../interfaces';

interface TrackOption {
  value: TBookingType;
  label: string;
}

interface ModalTrackExperienceSelectorProps {
  selectedTrack: TBookingType | string;
  onTrackSelect: (track: TBookingType | string) => void;
  tracks?: TrackOption[];
  className?: string;
}

const DEFAULT_TRACKS: TrackOption[] = [
  { value: "MAIN_TRACK", label: "Main Track" },
  { value: "JUNIOR_TRACK", label: "Junior Track" },
  { value: "MINI_TRACK", label: "Mini Track" },
  { value: "VR", label: "Virtual Reality" }
];

const ModalTrackExperienceSelector: React.FC<ModalTrackExperienceSelectorProps> = ({
  selectedTrack,
  onTrackSelect,
  tracks = DEFAULT_TRACKS,
  className = "",
}) => {

    const handleTrackSelect = useCallback((track: TBookingType) => () => {
        onTrackSelect(track);
    }, [onTrackSelect])

  return (
    <div className={`grid grid-cols-4 gap-2 ${className}`}>
      {tracks.map((track) => (
        <div
          key={track.value}
          className={`p-2 rounded-md text-center text-xs font-medium cursor-pointer text-white ${
            selectedTrack === track.value
              ? "bg-gradient-to-r from-purple-500 to-purple-600"
              : "bg-gray-400 hover:bg-gradient-to-r hover:from-purple-500 hover:to-purple-600"
          }`}
          onClick={handleTrackSelect(track.value)}
        >
          {track.label}
        </div>
      ))}
    </div>
  );
};

export default ModalTrackExperienceSelector;